import React from 'react';
import {Controls, ControlsItem, Divider, PageContent, Typography} from '@genestack/ui';
import * as biokbIcons from '../icons';
import * as uikitIcons from '../icons/ui-kit-icons';
import styles from './icon-gallery.module.css';

interface IconPlateProps {
    icon: React.ReactElement;
    name: string;
}

function IconPlate({icon, name}: IconPlateProps) {
    return (
        <div
            style={{
                padding: '8px 16px',
                width: '90px',
                height: '65px',
                display: 'inline-block'
            }}
        >
            <Controls gap={4} style={{display: 'flex', flexDirection: 'column'}}>
                <ControlsItem>{icon}</ControlsItem>
                <Divider variant="transparent" gap={1} />
                <ControlsItem className={styles.iconLabel}>
                    <Typography intent="quiet" variant="caption">
                        {name}
                    </Typography>
                </ControlsItem>
            </Controls>
        </div>
    );
}

export const IconGallery = () => {
    const allIcons: {[key: string]: React.FunctionComponent} = {...biokbIcons, ...uikitIcons};

    return (
        <PageContent className={styles.iconGallery}>
            <Typography variant="title">Icon gallery</Typography>

            <div>
                {Object.keys(allIcons)
                    .sort()
                    .map((iconName) => {
                        const Icon = allIcons[iconName];
                        return <IconPlate key={iconName} icon={<Icon />} name={iconName} />;
                    })}
            </div>
        </PageContent>
    );
};
